import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { NavMenu } from '@uhg-abyss/web/ui/NavMenu';
import { StateRouter } from '@uhg-abyss/web/ui/StateRouter';
import React from 'react';
import { checkInternalRole } from '@src/common/Utils/utils';

const getDropdownMenuContent = (
  menu,
  menuTitle,
  eventTitle,
  type,
  fireHeaderEvent,
  routeToPage
) => {
  return (
    <React.Fragment>
      <NavMenu.Trigger>{menuTitle}</NavMenu.Trigger>
      <NavMenu.Content>
        <NavMenu.Columns>
          <NavMenu.Column title={menuTitle}>
            {menu &&
              menu.leftSubMenu &&
              menu.leftSubMenu.map((item) => {
                return (
                  <NavMenu.MenuItem
                    title={item.title}
                    onClick={() => {
                      fireHeaderEvent(item.title, eventTitle);
                      routeToPage({
                        url: item.link,
                      });
                    }}
                  />
                );
              })}
          </NavMenu.Column>
          <NavMenu.Column>
            {menu &&
              menu?.rightSubMenu &&
              menu?.rightSubMenu.map((item) => {
                return (
                  <NavMenu.MenuItem
                    title={item.title}
                    onClick={() => {
                      fireHeaderEvent(item.title, eventTitle);
                      routeToPage({
                        url: item.link,
                      });
                    }}
                  />
                );
              })}
          </NavMenu.Column>
        </NavMenu.Columns>
      </NavMenu.Content>
    </React.Fragment>
  );
};

const getResourcesContent = (
  fireHeaderEvent,
  routeToPage,
  dsUserInfo,
  device
) => {
  const hasInternalRole = checkInternalRole(dsUserInfo);
  return device ? (
    <StateRouter.Route path="/home/Resources" title="Resources">
      <Heading
        css={{ padding: '0px $md' }}
        offset={4}
        fontWeight="$bold"
        id="utility-items-title"
      >
        Resources
      </Heading>
      <Layout.Stack
        grow
        as="ul"
        aria-labelledby="utility-items-title"
        css={{
          '&[li]': {
            listStyle: 'none',
            margin: 0,
            padding: 0,
          },
        }}
      >
        <li>
          <NavMenu.MenuItem
            title="Overview"
            onClick={() => {
              fireHeaderEvent('Overview', 'Resources');
              routeToPage({
                url: '/getting-started',
              });
            }}
          />
        </li>
        {dsUserInfo?.status &&
          dsUserInfo?.status === 'ACTIVE' &&
          !hasInternalRole && (
            <li>
              <NavMenu.MenuItem
                title="Credentials"
                onClick={() => {
                  fireHeaderEvent('Credentials', 'Resources');
                  routeToPage({
                    url: '/welcome/credentials',
                  });
                }}
              />
            </li>
          )}
        <Heading
          css={{ padding: '0px $md' }}
          offset={4}
          fontWeight="$bold"
          id="utility-items-title"
        >
          Additional Resources{' '}
        </Heading>
        <li>
          <NavMenu.MenuItem
            title="Release Notes"
            onClick={() => {
              fireHeaderEvent('Release Notes', 'Resources');
              routeToPage({
                url: '/welcome/release-notes/apim-latest-notes',
              });
            }}
          />
        </li>
      </Layout.Stack>
    </StateRouter.Route>
  ) : (
    <React.Fragment>
      <NavMenu.Trigger css={{ fontSize: '15px', fontWeight: 600 }}>
        Resources
      </NavMenu.Trigger>
      <NavMenu.Content>
        <NavMenu.Columns
          css={{
            '.abyss-nav-menu-column-title': {
              fontSize: '18px !important',
              fontWeight: '700 !important',
            },
            '.abyss-nav-menu-link-root': {
              padding: '4px 8px !important',
            },
            '.abyss-nav-menu-item-title': {
              fontSize: '16px !important',
              fontWeight: '700 !important',
            },
          }}
        >
          <NavMenu.Column
            title="Getting Started"
            css={{
              'abyss-nav-menu-column-root': {
                borderRight: '1px solid #e0e0e0',
              },
            }}
          >
            <NavMenu.MenuItem
              title="Overview"
              onClick={() => {
                fireHeaderEvent('Overview', 'Resources');
                routeToPage({
                  url: '/getting-started',
                });
              }}
            />
            {dsUserInfo?.status &&
              dsUserInfo?.status === 'ACTIVE' &&
              !hasInternalRole && (
                <NavMenu.MenuItem
                  title="Credentials"
                  onClick={() => {
                    fireHeaderEvent('Credentials', 'Resources');
                    routeToPage({
                      url: '/welcome/credentials',
                    });
                  }}
                />
              )}
          </NavMenu.Column>
          <NavMenu.Column title="Additional Resources">
            <NavMenu.MenuItem
              title="Release Notes"
              onClick={() => {
                fireHeaderEvent('Release Notes', 'Resources');
                routeToPage({
                  url: '/welcome/release-notes/apim-latest-notes',
                });
              }}
            />
          </NavMenu.Column>
        </NavMenu.Columns>
      </NavMenu.Content>
    </React.Fragment>
  );
};

const getCommunicationsCornerContent = (
  fireHeaderEvent,
  routeToPage,
  setShowSubscribeAPIModal,
  dsUserInfo,
  device
) => {
  return device ? (
    <StateRouter.Route
      path="/home/Communications Corner"
      title="Communications Corner"
    >
      <Heading
        css={{ padding: '0px $md' }}
        offset={4}
        fontWeight="$bold"
        id="utility-items-title"
      >
        Communications Corner
      </Heading>
      <Layout.Stack
        grow
        as="ul"
        aria-labelledby="utility-items-title"
        css={{
          '&[li]': {
            listStyle: 'none',
            margin: 0,
            padding: 0,
          },
        }}
      >
        <li>
          <NavMenu.MenuItem
            title="Connect with a Consultant"
            onClick={() => {
              fireHeaderEvent(
                'Connect with a Consultant',
                'Communications Corner'
              );
              const isConnected =
                dsUserInfo.status === 'ACTIVE' ||
                dsUserInfo.status === 'PENDING' ||
                dsUserInfo.status === 'DENIED';
              if (!isConnected) {
                routeToPage({
                  url: '/welcome/intake',
                });
              } else {
                setShowSubscribeAPIModal(true);
              }
            }}
          />
        </li>
        {dsUserInfo?.status && dsUserInfo?.status === 'ACTIVE' && (
          <li>
            <NavMenu.MenuItem
              title="All Communications"
              onClick={() => {
                fireHeaderEvent('All Communications', 'Communications Corner');
                routeToPage({
                  url: '/welcome/all-communications',
                });
              }}
            />
          </li>
        )}
      </Layout.Stack>
    </StateRouter.Route>
  ) : (
    <React.Fragment>
      <NavMenu.Trigger css={{ fontSize: '15px', fontWeight: 600 }}>
        Communications Corner
      </NavMenu.Trigger>
      <NavMenu.Content>
        <NavMenu.Columns
          css={{
            '.abyss-nav-menu-column-title': {
              fontSize: '18px !important',
              fontWeight: '700 !important',
            },
            '.abyss-nav-menu-link-root': {
              padding: '4px 8px !important',
            },
            '.abyss-nav-menu-item-title': {
              fontSize: '16px !important',
              fontWeight: '700 !important',
            },
          }}
        >
          <NavMenu.Column title="Communications Corner">
            <NavMenu.MenuItem
              title="Connect with a Consultant"
              onClick={() => {
                fireHeaderEvent(
                  'Connect with a Consultant',
                  'Communications Corner'
                );
                const isConnected =
                  dsUserInfo.status === 'ACTIVE' ||
                  dsUserInfo.status === 'PENDING' ||
                  dsUserInfo.status === 'DENIED';
                if (!isConnected) {
                  routeToPage({
                    url: '/welcome/intake',
                  });
                } else {
                  setShowSubscribeAPIModal(true);
                }
              }}
            />
          </NavMenu.Column>
          {dsUserInfo?.status && dsUserInfo?.status === 'ACTIVE' && (
            <NavMenu.Column
              title="Communications Corner"
              css={{
                'abyss-nav-menu-column-root': { borderLeft: 'none !important' },
                'abyss-nav-menu-column-title': { visibility: 'hidden' },
              }}
            >
              <NavMenu.MenuItem
                title="All Communications"
                onClick={() => {
                  fireHeaderEvent(
                    'All Communications',
                    'Communications Corner'
                  );
                  routeToPage({
                    url: '/welcome/all-communications',
                  });
                }}
              />
            </NavMenu.Column>
          )}
        </NavMenu.Columns>
      </NavMenu.Content>
    </React.Fragment>
  );
};

export {
  getDropdownMenuContent,
  getResourcesContent,
  getCommunicationsCornerContent,
};
